import { render } from "./Pagination.vue?vue&type=template&id=1e8f7940"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"
script.render = render

export default script